import { render, staticRenderFns } from "./procurementPlanTemplate.vue?vue&type=template&id=3fc227bf&scoped=true"
import script from "./procurementPlanTemplate.vue?vue&type=script&lang=js"
export * from "./procurementPlanTemplate.vue?vue&type=script&lang=js"
import style0 from "./procurementPlanTemplate.vue?vue&type=style&index=0&id=3fc227bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc227bf",
  null
  
)

export default component.exports